import React from "react";
import { Link } from "react-router-dom";

function HowItWorks() {
  return (
    <>
      <section className="hero" style={{ padding: "80px 24px 70px" }}>
        <div className="container">
          <h1>How to Get <span>Comp'd</span></h1>
          <p>It's simple. Tell us where you play, show us your offers, and we'll match you with the best comp'd experiences available.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Browse Events</h3>
              <p>Explore our curated selection of comp'd casino cruises, resort stays, meetups, and flash deals from top hosts and properties.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Submit Your Info</h3>
              <p>Tell us which casinos you play at, your loyalty tier, and share any current offers you've received. This helps us verify your qualification.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Get Qualified</h3>
              <p>Our host partners review your play history and offers. If you qualify, you'll receive confirmation and booking details within 24-48 hours.</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Enjoy Your Comp</h3>
              <p>Pack your bags. Enjoy comp'd rooms, meals, entertainment, and more at some of the finest casino destinations in the world.</p>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: "48px" }}>
            <Link to="/events" className="btn btn-primary">Browse Available Events</Link>
          </div>
        </div>
      </section>

      <section className="section" style={{ background: "var(--white)" }}>
        <div className="container">
          <div className="section-header">
            <h2>What Qualifies You?</h2>
            <p>Qualification varies by event and host. Generally, you'll need one or more of the following.</p>
          </div>
          <div className="qual-cards">
            <div className="qual-card">
              <div className="icon">🎰</div>
              <h3>Active Play History</h3>
              <p>Regular play at one or more casino properties with a player's card or loyalty account.</p>
            </div>
            <div className="qual-card">
              <div className="icon">📧</div>
              <h3>Current Offers</h3>
              <p>Casino mailers, email offers, or host invitations that demonstrate your play level.</p>
            </div>
            <div className="qual-card">
              <div className="icon">🏆</div>
              <h3>Loyalty Status</h3>
              <p>Higher tier levels (Gold, Platinum, Diamond) unlock premium comp'd experiences.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default HowItWorks;
